<template >
  <div name="evidenceadd" class="-mx-3 -mt-4">

    <section v-if="errored" class="w-full text-center mt-6">
              <h3 class="font-bold text-xl text-action-red">There was an issue adding the evidence details. </h3>
              <p class="text-action-blue">Please try again shortly or contact us to resolve the issue.</p>
            </section>



              <form
                v-on:submit.prevent="submitEvidence" id="evidenceForm" ref="form"
                v-if="!isEvidenceComplete"
                class=""
              >
              <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
          <div class="mx-6">

             <label class="font-semibold">Evidence record</label>

                  <div  class=" mt-2 w-full">
                  <upload
                      :currentFile="fileUrl"
                      @fileuploaded="setFile"
                    ></upload>
                    <p class="text-red-300 text-xs italic">
                      Please fill out this field.
                    </p>
                  </div>
              </div>
              </div>
                  

              <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
          <div class="mx-6">

             <label class="font-semibold">Class / Group</label>

                  
                    <div class="mt-2 w-1/2 -ml-1">
                    <ClassDropdown :classSelected="selectedClass" @classValueChanged="setClassName"></ClassDropdown>
                  </div>
                    <p class="text-red-300 text-xs italic pt-1">
                      Please fill out this field.
                    </p>
                  </div>
                </div>


                <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
          <div class="mx-6">

             <label class="font-semibold"> Associated lesson</label>

   

                    <ul class="mt-2 mb-1">
                      <li v-for="item in lessons" :key="item.id" class="inline-block mr-2">
                        <button
                          type="button"
                          @click="setLesson(item)"
                          class="selection-button mb-3 hover:bg-opacity-50 wide"
                          v-bind:class="
                            lessonButtonPressed(item)
                            ? 'filter-item-button-on'
                  : 'filter-item-button-off'
                          "
                        >
                          {{ item.name }}
                        </button>
                      </li>
                    </ul>
                    <p class="text-red-300 text-xs italic pt-1">
                      Please fill out this field.
                    </p>
                  </div>
                </div>

                <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300 mr-6">
        <div class="mx-6">
          
          <div class="font-semibol flex justify-between w-full pb-4">Notes
                    <div class="flex"> 
                      <div class="bg-blue-500 tag-example mr-2 w-10"
                      @click="addTags('sen')">#sen</div>

                      <div class="bg-orange-500 tag-example"
                      @click="addTags('ofsted')">#ofsted</div>
                    </div>
                    
                  </div>
               
                    <textarea
                      v-model="description"
                      rows="3"
                      class="p-1 mr-2"
                    ></textarea>
                  </div>
                </div>

                <footer
                  class="mb-20"
                >
                  <p
                    v-if="validationInError"
                    class="bg-red-400 rounded w-11/12 text-white p-4 mt-2"
                  >
                    <i class="fas fa-exclamation-circle pr-2 text-xl"></i>All
                    required fields must be complete to upload evidence
                  </p>

                  <div class="h-10 text-left w-11/12 mt-6 ml-6 mb-20 pb-4">
                   <button
                   @click="submitForm()"
          type="button"
                    :disabled="isDisabled"
                    class="publish-button hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4"

                  >
                    Upload Evidence
                  </button>
                </div>
                </footer>
              </form>


              <section v-if="isEvidenceComplete" class="w-full text-center mt-10">
              <h3 class="font-bold text-xl text-action-blue">Evidence details have been added. </h3>
              <p class="text-action-blue">The evidence details can be viewed or editied in the main evidence listing.</p>
              <button
                @click="isEvidenceComplete = false"
                type="button"
                class="publish-button hover:bg-blue-300 mt-4"
              >
                Add another item of evidence
              </button>
            </section>

              <template v-if="isEvidenceComplete && 1==3">
                <div class="boxer">
                  <div class="w-full px-3">
                    <label class="boxer-header" for="grid-outline">
                      Add pupils
                    </label>
                    <div class="h-1/2 pb-4 max-h-screen overflow-y-scroll">
                      <h5 class="mb-6 ml-2 font-semibold text-orange-500">
                        {{ pupilsSelected.length }} pupils selected
                      </h5>

                      <div
                        class="flex flex-wrap opacity-100"
                        v-if="pupilsLoaded"
                      >
                        <div
                          v-for="pupil in orderedPupils" :key="pupil.identifier"
                          @click="selectPupil(pupil)"
                          class="
                            relative
                            text-center
                            block
                            mx-2
                            mb-4
                            p-2
                            w-32
                            cursor-pointer
                            hover:opacity-75
                          "
                        >
                          <div
                            class="
                              absolute
                              right-0
                              mr-6
                              top-0
                              mt-1
                              text-white
                              p-1
                              rounded-full
                              h-8
                              w-8
                            "
                            v-bind:class="selectedPupilStyle(pupil)"
                          >
                            <i class="fas fa-check text-lg pt-1"></i>
                          </div>
                          <div
                            class="
                              mx-auto
                              rounded-full
                              h-16
                              w-16
                              mb-2
                              bg-gray-500
                            "
                          >
                            <i
                              class="fas fa-user text-3xl text-gray-200 pt-4"
                            ></i>
                          </div>
                          <div class="text-xs font-semibold">
                            {{ pupil.name }}
                          </div>
                        </div>
                      </div>
                      <p class="m-5 mx-12" v-else>
                        We could not find any data for your given selection.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="boxer" v-if="1==4">
                  <div class="w-full px-3">
                    <label class="boxer-header" for="grid-outline">
                      Add outcomes
                    </label>
                    <div class="h-1/2 pb-4 max-h-screen overflow-y-scroll">
                      <h5 class="mb-6 ml-2 font-semibold text-orange-500">
                        {{ outcomesSelected.length }} outcomes selected
                      </h5>

                      <table
                        v-if="outcomesLoaded"
                        class="
                          table-wrapper
                          w-full
                          bg-white
                          mx-auto
                          rounded
                          shadow-sm
                        "
                      >
                        <tbody v-for="section in outcomeSections" :key="section.value">
                          <tr>
                            <td colspan="2" class="text-sm uppercase font-bold">
                              {{ section.value }}
                            </td>
                          </tr>
                          <tr
                            v-for="(item, index) in outcomesOrderedBySection(
                              section.key
                            )"
                            :key="index"
                          >
                            <td width="90%">
                              <span
                                class="
                                  txt-xs
                                  italic
                                  text-gray-500
                                  mr-2
                                  inline-block
                                  float-left
                                  h-10
                                "
                                >{{ index + 1 }})</span
                              >
                              <span class="inline"> {{ item.title }}</span>
                            </td>
                            <td class="text-right">
                              <div
                                @click="selectOutcome(item)"
                                class="
                                  text-white
                                  p-1
                                  text-center
                                  rounded-full
                                  h-8
                                  w-8
                                  cursor-pointer
                                  hover:opacity-75
                                "
                                v-bind:class="selectedOutcomeStyle(item)"
                              >
                                <i class="fas fa-check text-base pt-1"></i>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p class="m-5 mx-12" v-else>
                        We could not find any data for your given selection.
                      </p>
                    </div>
                  </div>
                </div>

                <footer
                  class="h-24 border-t border-gray-400 border-solid mt-4 mb-48"
                >
                  <p
                    v-if="validationInError"
                    class="bg-red-400 rounded w-11/12 text-white p-4 mt-2"
                  >
                    <i class="fas fa-exclamation-circle pr-2 text-xl"></i>All
                    required fields must be complete to upload evidence
                  </p>
                  <button
                    @click="$emit('close')"
                    class="
                      bg-blue-400
                      hover:bg-blue-500
                      text-white
                      py-2
                      px-4
                      rounded
                      mt-6
                      w-40
                    "
                  >
                    Back to evidences
                  </button>
                </footer>
              </template>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EvidenceService } from "@/services/evidence.service";
import { OutcomeService } from "@/services/outcome.service";
import { calendarYearList } from "@/assets/js/utils";


const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");
const upload = () => import("@/components/evidence/EvidenceUpload.vue");

export default {
  name: "evidenceadd",
  props: {
    lessons: { type: Array, required: true },
    pupils: { type: Array, required: true },
    classPreset: { type: Object, required: false },
    lessonPreset: { type: Object, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    isDisabled() {
      return this.lessonSelected.id === undefined || this.fileUrl.length === 0
   
    },
    outcomesLoaded() {
      return this.outcomes.length > 0;
    },
    outcomesOrdered() {
      return _.orderBy(this.outcomes, ["order", "title"]);
    },
    outcomeSections() {
      let criteriaList = this.outcomesOrdered.map((o) => o.criteria);
      let distinct = [...new Set(criteriaList)];

      if (distinct.length === 0) {
        return { key: distinct, value: distinct.uppercase() };
      } else {
        return this.settings.assessmentCriteriaList.filter((a) =>
          distinct.includes(a.key)
        );
      }
    },
    pupilsLoaded() {
      return this.pupils.length > 0;
    },
    orderedPupils() {
      var vm = this;
      var classChosen = vm.selectedClass;

      if (classChosen == undefined) {
        return _.orderBy(this.pupils, ["yeargroup", "class", "name"]);
      } else {
        var filtered = vm.pupils.filter(function (pupil) {
          let filtered = true;

          if (filtered) {
            if (classChosen.id > 0) {
              filtered = pupil.class === classChosen.name;
            }
          }
          return filtered;
        });

        return _.orderBy(filtered, ["yeargroup", "class", "name"]);
      }
    },
  },
  data() {
    return {
      school: this.$store.getters.school,
      errored: false,
      isComplete: false,

      selectedClass: {},
      description: "",
      fileUrl: "",
      validationInError: false,


      pupilsSelected: [],
      isAllSelected: false,
      isEvidenceComplete: false,
      lessonSelected: {},

      outcomes: [],
      outcomesSelected: [],
      evidence: null,
    };
  },
  created() {
    //this.fetchOutcomes();
  },
  mounted() {
    if ( (this.lessonPreset != undefined && this.lessonPreset.id > 0)) {
      this.lessonSelected = this.lessonPreset
    }

    if ( (this.classPreset != undefined && this.classPreset.id > 0)) {
      this.selectedClass = this.classPreset
    }
  },
  methods: {

    // fetchOutcomes() {
    //   console.log(this.settings.display.outcomes);
    //   OutcomeService.getByCourse(
    //     this.lessonSelected.course_id,
    //     this.settings.display.outcomes
    //   )
    //     .then((response) => (this.outcomes = response.data))
    //     .catch((err) => {
    //       console.log("Outcomes " + err);
    //       this.errored = true;
    //     });
    // },
    // outcomesOrderedBySection(section) {
    //   return this.outcomesOrdered.filter((o) => o.criteria === section);
    // },
    lessonButtonPressed(object) {
      return this.lessonSelected == null
        ? false
        : this.lessonSelected.id == object.id;
    },
    classButtonPressed(object) {
      return this.selectedClass == null
        ? false
        : this.selectedClass.id == object.id;
    },
    setClassName(item) {
      if (this.selectedClass == null || this.selectedClass.id != item.id) {
        this.selectedClass = item;
      }
    },
    setLesson(item) {
      if (this.lessonSelected == null || this.lessonSelected.id != item.id) {
        this.lessonSelected = item;
      }
    },
    setFile(value) {
      this.fileUrl = value.file;
      this.type = value.type;
    },
    addTags(value) {
      let seperator = this.description.length > 0 ? " #" : "#"
      this.description = this.description + seperator + value
    },
    processEvidence() {
      const className =
        this.selectedClass == undefined ? "" : this.selectedClass.name;

      let calendarYear = calendarYearList().find((y) => y.current === true);
      let payload = {
        title: "Evidence " + this.lessonSelected.name + " " + className,
        media_type: this.type,
        media_url: this.fileUrl,
        notes: this.description,
        lesson_id: this.lessonSelected.id,
        inclass: className,
        calendar_schoolyear: calendarYear.value,
      };

      EvidenceService.add(payload)
        .then((response) => this.completion(response.data))
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      if (this.$refs.form.requestSubmit === undefined) {
        this.submitEvidence();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    submitEvidence() {
      if (this.fileUrl === "" || this.lessonSelected === undefined) {
        this.validationInError = true;
        console.log("VLA")
      } else {
        this.processEvidence();
        console.log("PREDCEED")
      }
    },
    selectedPupilStyle(pupil) {
      let found = this.pupilsSelected.find(
        (p) => p.identifier === pupil.identifier
      );
      return found ? "bg-green-500" : "bg-gray-300";
    },
    selectPupil(pupil) {
      const vm = this;
      if (this.pupilsSelected.some((p) => p.identifier === pupil.identifier)) {
        EvidenceService.deletePupil(vm.evidence, pupil)
          .then((response) => {
            vm.pupilsSelected.splice(
              vm.pupilsSelected.findIndex(
                (item) => item.identifier === pupil.identifier
              ),
              1
            );
          })
          .catch((err) => {
            vm.failure(err);
          });
      } else {
        let payload = {
          evidence_identifier: vm.evidence.identifier,
          register_identifier: pupil.identifier,
        };
        EvidenceService.addPupil(payload)
          .then((response) => {
            vm.pupilsSelected.push(pupil);
          })
          .catch((err) => {
            vm.failure(err);
          });
      }
    },
    selectOutcome(outcome) {
      const vm = this;
      if (
        vm.outcomesSelected.some((o) => o.identifier === outcome.identifier)
      ) {
        EvidenceService.deleteOutcome(vm.evidence, outcome)
          .then((response) => {
            vm.outcomesSelected.splice(
              vm.outcomesSelected.findIndex(
                (item) => item.identifier === outcome.identifier
              ),
              1
            );
          })
          .catch((err) => {
            vm.failure(err);
          });
      } else {
        let payload = {
          evidence_identifier: vm.evidence.identifier,
          outcome_identifier: outcome.identifier,
        };
        EvidenceService.addOutcome(payload)
          .then((response) => {
            vm.outcomesSelected.push(outcome);
          })
          .catch((err) => {
            vm.failure(err);
          });
      }
    },
    selectedOutcomeStyle(outcome) {
      let found = this.outcomesSelected.find(
        (o) => o.identifier === outcome.identifier
      );
      return found ? "bg-green-500" : "bg-gray-300";
    },
    completion(response) {
      this.evidence = response;
      if (this.evidence != undefined) {
        this.isEvidenceComplete = true
       this.$emit('evidence-added')
      }
      this.$emit('evidence-added')
      window.scrollTo(0, 0);
    },
    failure(error) {
      this.isEvidenceComplete = false
      this.errored = true
      console.log("Evidence update error " + error);
    },
  },
  components: {
    upload,
    ClassDropdown
  },
};
</script>

<style scoped>
.section-head {
  @apply text-xl m-5 ml-0 font-bold text-orange-500;
}

.boxer {
  @apply mb-8 bg-gray-100 py-3 rounded border border-gray-300;
}

.boxer-header {
  @apply block uppercase tracking-wide text-blue-700 text-sm font-bold mb-3;
}
</style>